var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M12,16c-1.1,0-2.1-0.4-2.8-1.2C8.4,14.1,8,13.1,8,12c0-1.1,0.4-2.1,1.2-2.8C9.9,8.4,10.9,8,12,8 c1.1,0,2.1,0.4,2.8,1.2C15.6,9.9,16,10.9,16,12s-0.4,2.1-1.2,2.8S13.1,16,12,16z M12,10c-0.5,0-1,0.2-1.4,0.6 C10.2,11,10,11.5,10,12s0.2,1,0.6,1.4c0.7,0.7,2.1,0.7,2.8,0C13.8,13,14,12.5,14,12s-0.2-1-0.6-1.4C13,10.2,12.5,10,12,10z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M12,20c-4.8,0-9-3.1-10.5-7.7c-0.1-0.2-0.1-0.4,0-0.6C2.9,7.1,7.2,4,12,4c4.8,0,9,3.1,10.5,7.7 c0.1,0.2,0.1,0.4,0,0.6C21,16.9,16.8,20,12,20z M3.5,12c1.3,3.6,4.6,6,8.5,6s7.2-2.4,8.5-6c-1.3-3.6-4.6-6-8.5-6S4.8,8.4,3.5,12z"
  }))));
};
export default SvgEyeOpen;